import React, { useLayoutEffect, useRef } from "react";
import { SovosCustomThemePage } from "mosaic-react";
import {
    ACTIONS,
    useCustomTheme,
    useDispatchCustomTheme,
} from "mosaic-react/sovos-custom-theme-context";
import { connect } from "react-redux";
import { mosaicThemeConfigChange } from "../../store/actions/themeAction";

/**
 * Component wrapper for SovosCustomThemePage with theme change detection
 * Follows the official Mosaic React documentation pattern
 */
const CustomThemePageExample = ({ onThemeChange }) => {
    const dispatch = useDispatchCustomTheme();
    const customTheme = useCustomTheme();
    const lastThemeRef = useRef(null);

    // Monitor theme changes and notify parent component
    useLayoutEffect(() => {
        if (!customTheme || !onThemeChange) return;

        const currentThemeStr = JSON.stringify(customTheme);
        const lastThemeStr = JSON.stringify(lastThemeRef.current);
        // Only trigger change if theme actually changed and is valid
        if (
            currentThemeStr !== lastThemeStr &&
            currentThemeStr !== "{}" &&
            currentThemeStr !== "null"
        ) {
            lastThemeRef.current = customTheme;
            onThemeChange(customTheme);
        }
    }, [customTheme, onThemeChange]);

    // Handle file uploads for logo - follows official documentation
    const handleFilesSelected = (event) => {
        const file = event[0];
        if (!file) return;

        const reader = new FileReader();
        reader.addEventListener(
            "loadend",
            () => {
                dispatch({
                    type: ACTIONS.SET_LOGO_URL,
                    payload: { value: reader.result },
                });
            },
            false,
        );

        reader.readAsDataURL(file);
    };

    return <SovosCustomThemePage onFilesSelected={handleFilesSelected} showFileUpload />;
};

/**
 * Theme Tab Component for Organization Form
 * Integrates Mosaic React's custom theme functionality with form persistence
 */
const ThemeTab = ({ data, handleChange, mosaicThemeConfigChange, styles }) => {
    /**
     * Handle theme changes from the Mosaic Custom Theme Page
     * Saves to both form state (for DB persistence) and Redux (for global state)
     */
    if (!data) return;
    const handleThemeChange = (themeData) => {
        if (!themeData) return;

        // Create a proper synthetic event object
        const syntheticEvent = {
            target: { value: themeData },
            preventDefault: () => {},
            stopPropagation: () => {},
            type: "change",
        };

        // Save to form for database persistence
        handleChange(syntheticEvent, "mosaicThemeConfig", themeData);

        // Update global Redux state for immediate UI changes
        mosaicThemeConfigChange(themeData);
    };

    return (
        <div className={styles["group-content"]}>
            <CustomThemePageExample onThemeChange={handleThemeChange} />
        </div>
    );
};

export default connect(
    null, // não precisamos de mapStateToProps
    {
        mosaicThemeConfigChange,
    },
)(ThemeTab);
